import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api";

/** Map first route segment to a readable page name */
function routeToPageName(pathname: string): string | null {
  const segment = pathname.replace(/^\//, "").split("/")[0] || "dashboard";

  const map: Record<string, string> = {
    "": "dashboard",
    matters: "matters",
    clients: "clients",
    contacts: "contacts",
    billing: "billing",
    accounting: "accounting",
    documents: "documents",
    esign: "esign",
    calendar: "calendar",
    leads: "leads",
    communications: "messaging",
    notifications: "notifications",
    reports: "reports",
    settings: "settings",
  };

  return map[segment] || null; // null = don't track unknown routes
}

/**
 * Tracks page visits by POSTing to /api/activity/page on route change.
 * Fire-and-forget — never blocks UI or surfaces errors.
 */
export function usePageTracker() {
  const location = useLocation();
  const lastTracked = useRef("");

  useEffect(() => {
    const page = routeToPageName(location.pathname);
    if (!page || page === lastTracked.current) return;

    const token = localStorage.getItem("accessToken");
    if (!token) return;

    lastTracked.current = page;

    api.post("/api/activity/page", { page }).catch(() => {});
  }, [location.pathname]);
}
